import React from 'react';
import { useTranslation } from 'react-i18next';

function FooterOfficeHours() {
    const [t] = useTranslation('footer');

    return (
        <div className={'flex flex-col sm:items-end'}>
            <div>
                <p className={'mb-3 text-base font-bold uppercase tracking-wider text-white'}>{t('office_hours')}</p>
                <p className={'text-base text-white'}>{`${t('mon_fri')}: ${t('schedule')}`}</p>
                <p className={'text-base text-white'}>{`${t('sat_sun')}: ${t('closed')}`}</p>
            </div>
        </div>
    );
}

export default FooterOfficeHours;
